import styled from 'styled-components';
export const Truncate = styled.div.withConfig({ displayName: "vui--Truncate", componentId: "vui--1qn89sr" }) `overflow:hidden;text-overflow:ellipsis;white-space:nowrap;`;
//# sourceMappingURL=Truncate.js.map